;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.8";import * as Sentry from '@sentry/nextjs';

import { beforeSend, shouldCreateSpanForRequest } from './utils/capture';

const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NEXT_PUBLIC_NODE_ENV,
    tracesSampleRate: 0.1,
    integrations: [
      Sentry.browserTracingIntegration({ shouldCreateSpanForRequest }),
    ],
    ignoreErrors: [
      // Thrown by the script the Facebook Android in-app browser injects
      // (navigation_performance_logger_android) when its native bridge is
      // torn down on beforeunload. Not our code and not user-facing.
      'Java object is gone',
      // Same script in the Instagram Android in-app browser, when the bridge's
      // Java side throws instead of being gone. Only a WebView JavaScript
      // interface raises this, and we never register one.
      'Java exception was raised during method invocation',
      // The iOS twin: the Instagram in-app browser's injected
      // sendPageHideMessage script reads window.webkit.messageHandlers on
      // pagehide after its native bridge is gone. Not our code either.
      'window.webkit.messageHandlers',
      // Sentry appends the host to a failed fetch's "Load failed" / "Failed to
      // fetch" / "NetworkError…" message. We only load Storyblok images through
      // <img>, never fetch(), so a failed fetch to a.storyblok.com comes from
      // the browser re-fetching images itself (seen from Opera Touch on iOS).
      '(a.storyblok.com)',
    ],
    beforeSend,
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
